import angular from "angular";

angular
    .module('app')
    .component('notificationForm', {
        template: require('./notification-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.notify = null;

    $ctrl.$onInit = function () {
        $ctrl.notify = $ctrl.resolve.notification;
    };
}